import { render } from "./aboutSection.vue?vue&type=template&id=60a1386a&scoped=true"
import script from "./aboutSection.vue?vue&type=script&lang=js"
export * from "./aboutSection.vue?vue&type=script&lang=js"

import "./aboutSection.vue?vue&type=style&index=0&id=60a1386a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a1386a"]])

export default __exports__